import axios from "axios";

export const callExternalApi = async (options) => {
  try {
    const response = await axios(options.config);
    const { data } = response;

    return {
      data,
      error: null,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error;
      const { response } = axiosError;

      let errorMessage = "http request failed";

      // Build a rich error object
      if (response) {
        // If we have response data with detail (like our HTTP exceptions from FastAPI)
        if (response.data?.detail) {
          throw {
            message: typeof response.data.detail === 'object' 
              ? response.data.detail.message 
              : response.data.detail,
            details: response.data.detail,
            status: response.status,
            response: response
          };
        } else if (response.data?.message) {
          // If we have a message in response data
          errorMessage = response.data.message;
        } else if (response.statusText) {
          // Fallback to status text
          errorMessage = response.statusText;
        }

        // Throw error with all relevant information
        throw {
          message: errorMessage,
          status: response.status,
          response: response
        };
      }

      // If no response object (network error etc)
      throw {
        message: axiosError.message,
        status: 0,
        isNetworkError: true
      };
    }

    // For non-axios errors
    throw error;
  }
};
